import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AppointmentService } from 'src/app/pages/appointment/appointment.service';
import { WaitingListService } from 'src/app/pages/waiting-list/waiting-list.service';

@Component({
  selector: 'app-defer-appointment-action',
  templateUrl: './defer-appointment-action.component.html',
  styleUrls: ['./defer-appointment-action.component.scss']
})
export class DeferAppointmentActionComponent {

  @Input()
  id!: string;

  @Output()
  onAppointmentDefer = new EventEmitter<string>();

  appointmetnService = inject(AppointmentService);
  waitingListService = inject(WaitingListService);

  deferAppointment() {
    this.appointmetnService.deferAppointment(this.id).subscribe(() => {
      this.onAppointmentDefer.emit(this.id!);
      this.appointmetnService.refetchPolling({});
      this.waitingListService.refetchWaitingList();
    });
  }
}
